"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendData;

/**
 * 发送埋点数据
 *
 * @export
 * @param {string} eventType - 事件类型
 * @param {string} eventParams -  自定义参数
 */
function sendData(eventType, eventParams) {
  window.scout_sensors && window.scout_sensors.track(eventType, eventParams);
}